/* BlackoutWorks theme — storefront behaviour.
   No framework, no build step. Everything degrades to a working page if JS fails. */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------------ toast */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.hidden = false; t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); setTimeout(function(){ t.hidden = true; }, 300); }, 2600);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* -------------------------------------------------- announcement rotation */
  (function () {
    var items = $$('#AnnBar .ann-item');
    if (items.length < 2) return;
    var i = 0, timer;
    function show(n) {
      items[i].hidden = true; items[i].classList.remove('on');
      i = (n + items.length) % items.length;
      items[i].hidden = false; items[i].classList.add('on');
    }
    function auto() { timer = setInterval(function () { show(i + 1); }, 5000); }
    $$('#AnnBar [data-ann]').forEach(function (b) {
      b.addEventListener('click', function () {
        clearInterval(timer);
        show(i + parseInt(b.getAttribute('data-ann'), 10));
        auto();
      });
    });
    auto();
  })();

  /* ------------------------------------------------------------ search bar */
  (function () {
    var bar = $('#searchbar'), btn = $('#searchBtn'), close = $('#searchClose'), input = $('#searchInput');
    if (!bar || !btn) return;
    btn.addEventListener('click', function () {
      bar.classList.toggle('open');          /* CSS reveals it with .searchbar.open */
      if (bar.classList.contains('open') && input) input.focus();
    });
    if (close) close.addEventListener('click', function () { bar.classList.remove('open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') bar.classList.remove('open'); });
  })();

  /* ------------------------------------------------------------ mobile nav */
  (function () {
    var burger = $('#burger'), nav = $('#nav');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () { nav.classList.toggle('open'); });
  })();

  /* ----------------------------------------------------------- cart drawer */
  var drawer = $('#CartDrawer'), scrim = $('#DrawerScrim');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('on'); scrim.classList.add('on'); });
    document.body.classList.add('lock');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('on'); scrim.classList.remove('on');
    document.body.classList.remove('lock');
    setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, 320);
  }

  function renderCart(cart) {
    var body = $('#DrawerBody'), foot = $('#DrawerFoot'), count = $('#CartCount');
    if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="empty-note">Your cart is empty</p>';
      foot.innerHTML = '';
      return;
    }

    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="">' : '';
      return '<div class="ci" data-key="' + it.key + '">' +
        '<a class="ci-img" href="' + it.url + '">' + img + '</a>' +
        '<div class="ci-body">' +
          '<a class="ci-name" href="' + it.url + '">' + it.product_title + '</a>' +
          (it.variant_title ? '<div class="ci-var">' + it.variant_title + '</div>' : '') +
          '<div class="ci-price">' + money(it.final_line_price) + '</div>' +
        '</div>' +
        '<div class="ci-qty">' +
          '<button type="button" data-line-qty="-1" aria-label="Decrease">&minus;</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-line-qty="1" aria-label="Increase">+</button>' +
        '</div>' +
      '</div>';
    }).join('');

    var thresh = window.BW.freeShip;
    var meter = '';
    if (thresh > 0) {
      var left = thresh - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price * 100 / thresh));
      meter = '<div class="ship"><div class="ship-row"><span>' +
        (left > 0 ? 'Spend <b>' + money(left) + '</b> to get free shipping' : '<b>Free shipping unlocked</b>') +
        '</span></div><div class="ship-track"><i style="width:' + pct + '%"></i></div></div>';
    }

    foot.innerHTML = meter +
      '<div class="trow g"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<a class="btn btn-amber btn-block btn-lg" href="/checkout">Checkout</a>';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  if ($('#cartBtn')) {
    $('#cartBtn').addEventListener('click', function () {
      fetchCart().then(function (c) { renderCart(c); openDrawer(); });
    });
  }
  if ($('#DrawerClose')) $('#DrawerClose').addEventListener('click', closeDrawer);
  if (scrim) scrim.addEventListener('click', closeDrawer);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-line-qty]') : null;
    if (!btn) return;
    var row = btn.closest('.ci');
    var key = row.getAttribute('data-key');
    var current = parseInt(row.querySelector('.ci-qty span').textContent, 10);
    var next = current + parseInt(btn.getAttribute('data-line-qty'), 10);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, next) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* ---------------------------------------------- add to cart without reload */
  var pform = $('#ProductForm');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('#AddBtn');
      var original = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(pform) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.data.description || 'Could not add that'); return; }
          return fetchCart().then(function (c) { renderCart(c); openDrawer(); toast('Added to cart'); });
        })
        .catch(function () { toast('Something went wrong — try again'); })
        .finally(function () { btn.disabled = false; btn.textContent = original; });
    });
  }

  /* --------------------------------------------------------- qty steppers */
  $$('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = $('#Qty'); if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(b.getAttribute('data-qty'), 10);
      input.value = Math.max(1, next);
    });
  });

  /* ------------------------------------------------- variant option picker */
  (function () {
    var select = $('#VariantSelect');
    if (!select) return;
    var groups = $$('.opts');

    function currentOptions() {
      return groups.map(function (g) {
        var on = g.querySelector('.opt.on');
        return on ? on.getAttribute('data-value') : null;
      });
    }

    function apply() {
      var want = currentOptions().join('|');
      var match = null;
      $$('option', select).forEach(function (o) {
        if (o.getAttribute('data-options') === want) match = o;
      });
      if (!match) return;

      select.value = match.value;

      var price = $('#pdpPrice');
      if (price) {
        var cmp = match.getAttribute('data-compare');
        price.innerHTML = '<span class="now">' + match.getAttribute('data-price') + '</span>' +
                          (cmp ? ' <s class="was">' + cmp + '</s>' : '');
      }

      var available = match.getAttribute('data-available') === 'true';
      var stock = $('#pdpStock');
      if (stock) {
        var qty = parseInt(match.getAttribute('data-qty'), 10);
        var managed = match.getAttribute('data-managed');
        stock.innerHTML = available
          ? '<i class="dot ok"></i><span>' + (managed && qty > 0 ? qty + ' in stock' : 'In stock') + '</span>'
          : '<i class="dot no"></i><span>Sold out</span>';
      }

      var add = $('#AddBtn');
      if (add) { add.disabled = !available; add.textContent = available ? 'Add to cart' : 'Sold out'; }

      var img = match.getAttribute('data-image'), main = $('#pdpMain');
      if (img && main) {
        main.src = img;
        $$('#pdpThumbs .pdp-thumb').forEach(function (t) {
          t.classList.toggle('on', t.getAttribute('data-full') === img);
        });
      }
    }

    groups.forEach(function (g) {
      $$('.opt', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.opt', g).forEach(function (o) { o.classList.remove('on'); });
          b.classList.add('on');
          apply();
        });
      });
    });
  })();

  /* ------------------------------------------------------------- gallery */
  $$('#pdpThumbs .pdp-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = $('#pdpMain'); if (!main) return;
      main.src = t.getAttribute('data-full');
      $$('#pdpThumbs .pdp-thumb').forEach(function (o) { o.classList.remove('on'); });
      t.classList.add('on');
    });
  });

  /* --------------------------------------------------- shop-by-bike rail */
  (function () {
    var rail = $('#BikeRail');
    if (!rail) return;

    var SPEED = 0.2, RESUME_AFTER = 2200;   // pixels per frame -- lower is slower
    var pos = rail.scrollLeft, paused = false, resumeTimer;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function pause() {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; pos = rail.scrollLeft; }, RESUME_AFTER);
    }

    ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
      rail.addEventListener(ev, pause, { passive: true });
    });
    rail.addEventListener('mouseenter', function () { paused = true; });
    rail.addEventListener('mouseleave', function () { paused = false; pos = rail.scrollLeft; });

    $$('[data-rail]').forEach(function (b) {
      b.addEventListener('click', function () {
        pause();
        rail.scrollBy({ left: 320 * parseInt(b.getAttribute('data-rail'), 10), behavior: 'smooth' });
      });
    });

    var cards = $$('.bcard', rail).length;
    function updateProgress() {
      var max = rail.scrollWidth - rail.clientWidth;
      var pct = max > 0 ? rail.scrollLeft / max : 0;
      var prog = $('#RailProg'); if (prog) prog.style.width = Math.round(pct * 100) + '%';
      var idx = $('#RailIdx');
      if (idx && cards) {
        var n = Math.min(cards, Math.round(pct * (cards - 1)) + 1);
        idx.textContent = ('0' + n).slice(-2);
      }
    }
    rail.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    if (!reduce) {
      (function tick() {
        if (!paused) {
          var max = rail.scrollWidth - rail.clientWidth;
          pos += SPEED;
          if (pos >= max) pos = 0;
          rail.scrollLeft = pos;
        }
        requestAnimationFrame(tick);
      })();
    }
  })();

  /* ------------------------------------------------------ collection bar */
  (function () {
    var btn = $('#FilterBtn'), panel = $('#FilterPanel');
    if (btn && panel) btn.addEventListener('click', function () { panel.classList.toggle('on'); });
    var sort = $('#SortBy');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  })();

})();
